import { Button, LabeledCheckbox, Select } from '@nextiva/next-ui';
import { toCustomDateRange } from '../../../utils/date-range';
import { map, times } from 'lodash';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import Styles from "./RelativeOptions.module.scss";

const UNIT_OPTIONS = [
    { value: 'minute', label: 'Minutes' },
    { value: 'hour', label: 'Hours' },
    { value: 'day', label: 'Days' },
    { value: 'week', label: 'Weeks' },
    { value: 'month', label: 'Months' },
    { value: 'year', label: 'Years' },
];

const ROUND_LABELS = {
    minute: 'Rounded to nearest minute',
    hour: 'Rounded to nearest hour',
    day: 'Rounded to 12:00 AM',
    week: 'Rounded to Monday',
    month: 'Rounded to 1st of month',
    year: 'Rounded to 1st January',
    quarter: 'Rounded to 1st of quarter',
};

class RelativeOptions extends Component {
    constructor(props) {
        super(props);
        const initialDateRange = {
            type: 'relative',
            value: props.value,
            unit: props.unit,
            round: props.round,
        };
        this.state = {
            ...initialDateRange,
            label: this.getLabel(initialDateRange),
        };
    }

    getLabel = (dateRange) => {
        const { timezone } = this.props;
        const { start } = toCustomDateRange(dateRange, timezone);
        return moment.tz(start, timezone).format('MMMM Do hh:mm A');
    };

    setLabel = () => {
        const { value, unit, round } = this.state;
        this.setState({
            label: this.getLabel({ type: 'relative', value, unit, round }),
        });
    };

    handleValueChange = ({ value }) => {
        const { round } = this.state;
        this.setState(
            {
                value,
                round: value !== 0 ? round : true,
            },
            this.setLabel,
        );
    };

    handleUnitChange = ({ value }) => {
        this.setState(
            {
                unit: value,
            },
            this.setLabel,
        );
    };

    handleRoundChange = (checked) => {
        this.setState(
            {
                round: checked,
            },
            this.setLabel,
        );
    };

    handlePresetClick = (presetDateRange) => () => {
        this.setState(presetDateRange, this.setLabel);
    };

    handleSave = () => {
        const { value, unit, round } = this.state;
        this.props.onSave({
            type: 'relative',
            value,
            unit,
            round,
        });
    };

    getOptions = () => {
        const { unit } = this.state;
        return UNIT_OPTIONS.filter(
            option =>
                this.props.units.includes(option.value) || option.value === unit,
        );
    };

    getPresets = () =>
        Object.keys(this.props.presets).reduce(
            (acc, presetKey) => {
                if (this.props.units.includes(this.props.presets[presetKey].unit)) {
                    acc[presetKey] = this.props.presets[presetKey];
                }
                return acc;
            },
            {},
        );

    getValueOptionsCount = (unit) => {
        switch (unit) {
            case 'day':
                return 91;
            default:
                return 61;
        }
    };

    getValueOptions = (countElements) => {
        return times(countElements, value => ({
            value,
            label: value.toString(),
        }));
    };

    render() {
        const { value, unit, round, label } = this.state;
        const options = this.getOptions();
        const availablePresets = this.getPresets();
        const valueOptionsCount = this.getValueOptionsCount(unit);
        const valueOptions = this.getValueOptions(valueOptionsCount);

        return (
            <div className={Styles["drp-relative-options"]}>
                <div className={Styles["drp-relative-options__label"]}>
                    <span>{label}</span> to now
                </div>
                <div className={Styles["drp-relative-options__filter"]}>
                    <span className={Styles["drp-relative-options__prefix"]}>Filter from</span>
                    <Select
                        className={Styles["drp-relative-options__value"]}
                        portalMenuWrapperClassName="drp-relative-options__value-list"
                        options={valueOptions}
                        value={value}
                        onChange={this.handleValueChange}
                    />
                    <Select
                        className={Styles["drp-relative-options__unit"]}
                        portalMenuWrapperClassName="drp-relative-options__unit-list"
                        options={options}
                        value={unit}
                        onChange={this.handleUnitChange}
                    />
                    <span className={Styles["drp-relative-options__suffix"]}>ago to now.</span>
                </div>
                <LabeledCheckbox
                    containerClassName={Styles["drp-relative-options__round"]}
                    checked={round}
                    disabled={value === 0}
                    label={ROUND_LABELS[unit] || 'Rounded'}
                    size={14}
                    onChange={this.handleRoundChange}
                />
                <div className={Styles["drp-relative-options__footer"]}>
                    <div className={Styles["drp-relative-options__presets"]}>
                        {map(availablePresets, (preset, presetLabel) => (
                            <span key={presetLabel} onClick={this.handlePresetClick(preset)}>
                                {presetLabel}
                            </span>
                        ))}
                    </div>
                    <Button
                        kind="success"
                        className="drp-popover__btn-update"
                        onClick={this.handleSave}
                        data-testid="AnalyticsSpa-RealtiveOptions-UpdateButton"
                    >
                        Update
                    </Button>
                </div>
            </div>
        );
    }
}

export default RelativeOptions;
